module.exports = __webpack_public_path__ + "images/477f2fcc2236cd0e3cb0aa68077d6de0.png";